<template>
	<dms-list-layout v-bind="layoutProps">
		<div slot="filter">
			<dms-collapse :value.sync="mainCollapse">
			<dms-collapse-item label-key="GeneralCriteria">
			<dms-input :value.sync="CdbMethod" label-key="CDB_METHOD" />
			<dms-input :value.sync="Xmldoc" label-key="XMLDOC" />
			</dms-collapse-item>
			</dms-collapse>
		</div>
		<dms-table slot="content" v-bind="tableModel" v-on="tableListeners" />
	</dms-list-layout>
</template>

<script>
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store);
</script>
